import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-close",
  "use": "icon-close-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-close\">\n    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->\n    <title>icon24/folder/close</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"icon-close_icon24-symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-close_icon24/folder/close\" fill=\"#000000\">\n            <path d=\"M14,7 L19,7 C19.5522847,7 20,7.44771525 20,8 L20,18 C20,18.5522847 19.5522847,19 19,19 L5,19 C4.44771525,19 4,18.5522847 4,18 L4,8 L4,5 C4,4.44771525 4.44771525,4 5,4 L11,4 C11.5522847,4 12,4.44771525 12,5 C12,6.1045695 12.8954305,7 14,7 Z\" id=\"icon-close_Combined-Shape\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/close.svg
// module id = toIl
// module chunks = 54